import Vue from "vue";
import Router from "vue-router";
// import Home from "./views/Home.vue";
import Top from "./views/Top.vue";
// import AmplifyStore from "./store";
// import { AmplifyEventBus, AmplifyPlugin, components } from "aws-amplify-vue";
import { AmplifyPlugin } from "aws-amplify-vue";
import * as AmplifyModules from "aws-amplify";

Vue.use(Router);
Vue.use(AmplifyPlugin, AmplifyModules);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    /*
    {
      path: "/",
      name: "home",
      component: Home
    },
    */
    {
      path: "/",
      name: "top",
      component: Top
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/complete",
      name: "complete",
      component: () =>
        import("./views/Complete.vue")
    }
  ]
});
